import * as Popover from "@radix-ui/react-popover";
import React from "react";
import type { FontFamilyValues } from "@excalidraw/element/types";
import { LofiFontMenu } from "./LofiFontMenu";
import { LofiFontMenuTrigger } from "./LofiFontMenuTrigger";

interface LofiFontPickerWrapperProps {
  isOpened: boolean;
  selectedFontFamily: FontFamilyValues | null;
  onSelect: (fontFamily: FontFamilyValues) => void;
  onPopupChange: (open: boolean) => void;
}

export const LofiFontPickerWrapper = React.memo(
  ({
    isOpened,
    selectedFontFamily,
    onSelect,
    onPopupChange,
  }: LofiFontPickerWrapperProps) => {
    return (
      <div className="lofi-font-picker-wrapper">
        <Popover.Root open={isOpened} onOpenChange={onPopupChange}>
          <LofiFontMenuTrigger />
          {isOpened && (
            <LofiFontMenu
              selectedFontFamily={selectedFontFamily}
              onSelect={onSelect}
              onClose={() => onPopupChange(false)}
            />
          )}
        </Popover.Root>
      </div>
    );
  }
);

LofiFontPickerWrapper.displayName = "LofiFontPickerWrapper"; 